import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {PoliciesAlertsService} from "../../services/policies-alerts.service";
import {PoliciesDialogService} from "../../services/policies-dialogs-service.service";
import {PoliciesRequestsService} from "../../services/policies-requests.service";
import {PoliciesService} from "../../services/policies-service.service";

export class policyServiceAccountsViewCtrl implements IController {

  extendedPolicy: any;
  orgId: any;
  siteId: any;

  public rolesGroups: any;
  private queryString: any;
  private loading: any;

  /* @ngInject */
  constructor(private confirmDialogService: ConfirmDialogService,
              private policiesAlertsService: PoliciesAlertsService,
              private policiesDialogService: PoliciesDialogService,
              private policiesRequestsService: PoliciesRequestsService,
              private policiesService: PoliciesService, private $log,
              private $scope: angular.IScope) {
  }

  $onInit() {
    this.queryString = undefined;
    this.loading = false;

    if (this.extendedPolicy) {
      this.policiesService.getAllRolesGroups(this.extendedPolicy.policy.id, this.orgId, this.siteId)
        .then((groups: any) => {
          this.rolesGroups = groups;
        });
    }
  }

  submitQuery(query) {
    this.queryString = query;
  }

  onAddServiceAccount(event) {
    this.policiesDialogService.addServiceAccount(event, this.orgId, this.siteId, this.extendedPolicy.roles, this.extendedPolicy.policy.id, this.rolesGroups)
      .then((createdApiKey) => {
        this.extendedPolicy.bindings = this.extendedPolicy.bindings.concat(createdApiKey.bindings);
        this.extendedPolicy.serviceAccounts.push(createdApiKey.serviceAccount);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
      .finally(() => {
        this.loading = false;
      });
  }

  onEditServiceAccount(account, roles, rolesGroupIds, event) {
    const userGroupIds = _.map(rolesGroupIds, 'id');
    this.policiesDialogService.editUserRoles(event, account, roles, this.extendedPolicy.roles, userGroupIds, this.rolesGroups)
      .then((bindings: { roleId?: string[], rolesGroupId?: string[] }[]) => {
        this.loading = true;
        return this.policiesRequestsService.updateServiceAccount(
          this.extendedPolicy.policy.id,
          account.id,
          {bindings},
          this.orgId,
          this.siteId
        );
      })
      .then((updatedUserBindings) => {
        this.policiesAlertsService.updateRolesSuccess();

        let bindingsCopy = angular.copy(this.extendedPolicy.policy.bindings);
        bindingsCopy = bindingsCopy.filter((b) => {
          return b.memberId !== account.id;
        })

        bindingsCopy = bindingsCopy.concat(updatedUserBindings.bindings);
        this.extendedPolicy.policy.bindings = bindingsCopy;
      })
      .catch((error) => {
        if (error) {
          this.policiesAlertsService.updateRolesError();
          this.$log.error('Failed to update policy @adminUserView@onEditRoles', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
      })
  }

  onRemoveServiceAccount(account, event) {
    this.confirmDialogService.confirm('Remove API Key', 'Are you sure you want to remove this API Key?', event)
      .then(() => {
        this.loading = true;
        return this.policiesRequestsService.deleteServiceAccount(this.extendedPolicy.policy.id, account.id, this.orgId, this.siteId)
      })
      .then(() => {
        this.extendedPolicy.serviceAccounts = _.filter(this.extendedPolicy.serviceAccounts, (policyAccount) => {
          return policyAccount.id !== account.id;
        });
        this.policiesAlertsService.removeAPIKeySuccess();
      })
      .catch((error) => {
        this.policiesAlertsService.removeAPIKeyError();
        this.$log.error('Failed to remove API Key @policyView@onRemoveServiceAccount', error);
      })
      .finally(() => {
        this.$log.info('Dialog Closed');
        this.loading = false;
      });
  }

}

angular
  .module('bringoz.admin.policies')
  .component('policyServiceAccountsView', {
    bindings: {
      extendedPolicy: '<',
      orgId: '<?',
      siteId: '<?'
    },
    template: require('./policy-service-accounts-view.html').default,
    controller: policyServiceAccountsViewCtrl
  });
